"use client";

import QosmPanel from "./QosmPanel";

export function FetchAndStoreExample() {
  return (
    <QosmPanel
      prelude={
        "extern http_get  : {url: String} -> String ! {Http.Get};\n" +
        "extern db_insert : {key: String, value: String} -> Unit ! {Db.Insert};"
      }
      code={
        "let fetch_and_store url key =\n" +
        "  let data = http_get {url: url};\n" +
        "  db_insert {key: key, value: data};\n" +
        "\n" +
        "// The agent can only call http_get and db_insert.\n" +
        "// No file access. No LLM. Nothing else exists."
      }
      filename="fetch_and_store.qosm"
    />
  );
}

export function AttenuateExample() {
  return (
    <QosmPanel
      prelude="extern read_file : {path: String} -> String ! {File.Read};"
      code={
        "// Attenuate: restrict to a single directory.\n" +
        "let config_read path = read_file {path: \"/config/\" ++ path};\n" +
        "\n" +
        "// Attenuate further: a single file, no arguments.\n" +
        "let app_config _ = read_file {path: \"/config/app.toml\"};\n" +
        "\n" +
        "// The agent receives app_config.\n" +
        "// It cannot read anything else. Not by cleverness,\n" +
        "// not by prompt injection \u2014 by construction."
      }
      filename="attenuate.qosm"
    />
  );
}

export function ComposeExample() {
  return (
    <QosmPanel
      prelude="extern db_insert : {key: String, value: String} -> Unit ! {Db.Insert};"
      code={
        "let classify text =\n" +
        "  model @{category: String, confidence: Float}\n" +
        "  `Classify this text: {{ text }}`;\n" +
        "\n" +
        "let store label data =\n" +
        "  db_insert {key: label, value: toString data};\n" +
        "\n" +
        "let classify_and_store text =\n" +
        "  match classify text with (\n" +
        "  | Ok r -> store (.category r) r\n" +
        "  | Err e -> store \"error\" e);\n" +
        "\n" +
        "// Uses two capabilities: model and db_insert.\n" +
        "// The type tracks both. No surprises."
      }
      filename="compose.qosm"
    />
  );
}

export function McpPreludeExample() {
  return (
    <QosmPanel
      code={
        "// Auto-generated from connected MCP servers\n" +
        "\n" +
        "extern create_issue  : {repo: String, title: String, body: String}\n" +
        "                    -> {number: Int, url: String} ! {GitHub};\n" +
        "\n" +
        "extern search_repos  : {query: String, limit: Int}\n" +
        "                    -> Array<{name: String, stars: Int, url: String}> ! {GitHub};\n" +
        "\n" +
        "extern send_message  : {channel: String, text: String}\n" +
        "                    -> {ts: String} ! {Slack};\n" +
        "\n" +
        "extern query         : {sql: String, params: Array<String>}\n" +
        "                    -> Array<{row: {col: String, val: String}}> ! {PostgreSQL};\n" +
        "\n" +
        "extern create_charge : {amount: Int, currency: String, customer: String}\n" +
        "                    -> {id: String, status: String} ! {Stripe};\n" +
        "\n" +
        "extern web_search    : {query: String}\n" +
        "                    -> Array<{title: String, url: String, snippet: String}> ! {Linkup};"
      }
      filename="generated prelude"
    />
  );
}